import { Component, Input } from '@angular/core';
import { RelationInterface } from 'outshared-lib';
import { Observable } from 'rxjs';
import { IntersectionObserverService } from '@app/core/services/intersection-observer.service';

/** @deprecated - insurances functionality is moved to libs/my-zone/insurances */
@Component({
    selector: 'ins-passport-info',
    templateUrl: 'passport-info.component.html',
    styleUrls: [ 'passport-info.component.scss' ],
})
export class PassportInfoComponent {
    @Input() public relation?: RelationInterface;

    public isDetailsVisible: boolean;
    public isScreenSmall$: Observable<boolean> = this.intersectionObserverService.isScreenSmall$;

    constructor(private intersectionObserverService: IntersectionObserverService) {
        this.isDetailsVisible = false;
    }

    public onToggle(): void {
        this.isDetailsVisible = !this.isDetailsVisible;
    }
}
